<template>
  <div v-if="descarga" class="d-flex flex-row grey lighten-4 rounded-pill py-1 px-2 me-2">
    <v-btn
      id="btn-pos-escritorio"
      small
      rounded
      text
      color="primary"
      class="my-auto"
      title="Descargar el POS de escritorio"
      @click="abierto = true"
    >
      <v-icon left>mdi-desktop-tower-monitor</v-icon>
      <span class="d-none d-md-inline">POS de escritorio</span>
    </v-btn>

    <v-dialog v-model="abierto" max-width="520" :persistent="pasando">
      <v-card id="dialogo-pos-escritorio" class="pa-2">
        <v-card-title class="text-h6">POS de escritorio para Windows</v-card-title>

        <v-card-text v-if="!pasada">
          <p>
            Es este mismo POS instalado como un programa en el computador. Vende igual, pero
            guarda sus datos en el equipo y no en el navegador: un limpiador como CCleaner ya no
            desinstala la caja.
          </p>
          <p class="mb-1"><strong>1.</strong> Descarga e instala el programa en este computador.</p>
          <v-btn
            id="btn-descargar-escritorio"
            color="primary"
            depressed
            :href="descarga.url"
            class="mb-4"
          >
            <v-icon left>mdi-download</v-icon>
            Descargar (versión {{ descarga.version }}<span v-if="megas">, {{ megas }} MB</span>)
          </v-btn>
          <p class="caption grey--text text--darken-1">
            Windows puede avisar que el programa no es conocido: elige «Más información» y
            «Ejecutar de todas formas».
          </p>

          <template v-if="caja">
            <p class="mb-1">
              <strong>2.</strong> Cuando ya esté instalado, pasa la caja «{{ caja }}» al programa.
              Desde ese momento esta caja deja de vender en el navegador.
            </p>
            <v-btn
              id="btn-pasar-caja-escritorio"
              color="primary"
              outlined
              :loading="pasando"
              @click="pasarCaja"
            >Pasar esta caja a la app de escritorio</v-btn>
          </template>
        </v-card-text>

        <v-card-text v-else id="caja-pasada-escritorio">
          <p>
            Listo. La caja «{{ caja }}» ya no vende en el navegador.
          </p>
          <p>
            Abre <strong>Nubempresa POS</strong> desde el escritorio de Windows, entra con tu
            usuario e instala la caja «{{ caja }}».
          </p>
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn v-if="!pasada" text :disabled="pasando" @click="abierto = false">Cerrar</v-btn>
          <v-btn v-else id="btn-entendido-escritorio" color="primary" depressed @click="terminar">Entendido</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/**
 * Botón «POS de escritorio» del POS web (PLAN-POS-OFFLINE.md, fase 1). Sólo aparece si el backend
 * dice que la empresa lo tiene habilitado (`GET pos/escritorio`, primero las empresas piloto).
 *
 * «Pasar esta caja» suelta la caja desde este mismo equipo (`POST pos/cajas/{id}/soltar`, una caja,
 * un equipo) y la desinstala del navegador; luego se instala en la app.
 */
import { desinstalarCajaDeEsteEquipo } from '@/plugins/pos-equipo.js';

export default {
  name: 'DescargarEscritorio',
  data: () => ({
    descarga: null,
    abierto: false,
    pasando: false,
    pasada: false,
    cajaNombre: null,
  }),
  computed: {
    caja() {
      const installation = this.$store.getters.installation;
      return installation && installation.cash_id ? this.cajaNombre || 'de este equipo' : null;
    },
    megas() {
      return this.descarga && this.descarga.bytes ? Math.round(this.descarga.bytes / 1048576) : null;
    },
  },
  async mounted() {
    try {
      const r = await this.$http.get('api/v1/pos/escritorio', null, false, false, false);
      if (r && r.success && r.item && r.item.disponible) {
        this.descarga = r.item;
        const installation = this.$store.getters.installation;
        const caja = installation && installation.cash_id ? await this.$db.getCashRegister(installation.cash_id) : null;
        this.cajaNombre = caja ? caja.name : null;
      }
    } catch (e) {
      // sin el botón el POS sigue igual
    }
  },
  methods: {
    async pasarCaja() {
      if (!window.confirm(`¿Pasar la caja «${this.caja}» a la app de escritorio? Este navegador deja de vender en ella.`)) {
        return;
      }
      this.pasando = true;
      try {
        const installation = this.$store.getters.installation;
        const r = await this.$http.post(`api/v1/pos/cajas/${installation.cash_id}/soltar`, {}, false, false, true);
        if (r && r.success) {
          this.pasada = true;
        }
      } catch (e) {
        // el mensaje del servidor ya se mostró
      } finally {
        this.pasando = false;
      }
    },
    async terminar() {
      await desinstalarCajaDeEsteEquipo(this.$db, this.$store);
      window.location.reload();
    },
  },
};
</script>
